import { UNLOCK_WSPOS, UNLOCK_WSPOS_SUCCESSFUL, UNLOCK_WSPOS_FAILED } from './actionTypes';

const initialState = {
    unlockWSPositionError: null, messageUnlockWSPosition: null, loadingUnlockWSPosition: false
}

const unlockWSPosition = (state = initialState, action) => {
    switch (action.type) {
        case UNLOCK_WSPOS:
            state = {
                ...state,
                loadingUnlockWSPosition: true,
                unlockWSPositionError: null
            }
            break;
        case UNLOCK_WSPOS_SUCCESSFUL:
            state = {
                ...state,
                loadingUnlockWSPosition: false,
                messageUnlockWSPosition: action.payload,
                unlockWSPositionError: null
            }
            break;
        case UNLOCK_WSPOS_FAILED:
            state = {
                ...state,
                messageUnlockWSPosition: null,
                loadingUnlockWSPosition: false,
                unlockWSPositionError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default unlockWSPosition;